"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _defineProperty2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tablePage = _interopRequireDefault(require("@/components/CommonForm/table-page"));
var _leave = require("_a/office/leave/leave");
var _message = require("@/libs/message");
var _vuex = require("vuex");
var _trackProcess = _interopRequireDefault(require("@/views/office/task/track-process"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'leave-manage',
  components: {
    TrackProcess: _trackProcess.default,
    TablePage: _tablePage.default
  },
  data: function data() {
    return {
      columns: [{
        label: '姓名',
        prop: 'name'
      }, {
        label: '请假时间',
        prop: 'leaveDate'
      }, {
        label: '开始时间',
        prop: 'beginDate'
      }, {
        label: '结束时间',
        prop: 'endDate'
      }, {
        label: '请假类型',
        slot: 'type'
      }, {
        label: '请假事由',
        prop: 'reason'
      }, {
        label: '状态',
        slot: 'status'
      }, {
        label: '操作',
        slot: 'action'
      }],
      queryParams: {},
      dialogShow: false,
      dialogTrackShow: false,
      dialogTitle: '添加',
      form: {},
      rules: {
        name: [this.$ruler('姓名')],
        beginDate: [this.$ruler('开始时间')],
        endDate: [this.$ruler('结束时间')],
        type: [this.$ruler('请假类型')],
        reason: [this.$ruler('请假事由')]
      },
      leaveDate: [],
      leaveTypeOptionList: [],
      processInstanceId: null
    };
  },
  watch: {
    leaveDate: function leaveDate(newVal, oldVal) {
      if (newVal !== undefined && newVal !== null) {
        this.queryParams.beginDate = newVal[0];
        this.queryParams.endDate = newVal[1];
      }
    }
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['getDictListByType'])), {}, {
    change: function change(e) {
      this.$forceUpdate();
    },
    /**
     * 刷新
     */
    refresh: function refresh() {
      this.$refs.tablePage.refresh();
    },
    /**
     * 重置搜索条件
     */
    reset: function reset() {
      this.queryParams = {};
      this.$nextTick(function () {
        this.refresh();
      });
    },
    submit: function submit(row) {
      this.form = _objectSpread({}, row);
      this.form.leaveDate = [row.beginDate, row.endDate];
      this.dialogTitle = '提交';
      this.$nextTick(function () {
        this.dialogShow = true;
      });
    },
    reSubmit: function reSubmit(row) {
      this.form = _objectSpread({}, row);
      this.form.leaveDate = [row.beginDate, row.endDate];
      this.dialogTitle = '重新提交';
      this.$nextTick(function () {
        this.dialogShow = true;
      });
    },
    /**
     * 行内删除
     * @param row
     */
    remove: function remove(row) {
      var _this = this;
      (0, _message.ConfirmCustom)({
        type: 'warning'
      }).then(function () {
        (0, _leave.deleteLeaveById)(row.id).then(function (res) {
          if (res.data) {
            (0, _message.MessageSuccess)('del');
          } else {
            (0, _message.MessageError)('del');
          }
          // 刷新表格
          _this.refresh();
        });
      });
    },
    track: function track(row) {
      if (row.processInstanceId !== null) {
        this.processInstanceId = row.processInstanceId;
        this.$nextTick(function () {
          this.dialogTrackShow = true;
        });
      }
    },
    /**
     * 重置表单
     * @param name
     */
    handleReset: function handleReset(name) {
      this.dialogShow = false;
      this.$refs[name].resetFields();
    },
    /**
     * 提交表单
     * @param name
     */
    handleSubmit: function handleSubmit(name) {
      var _this2 = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          if (_this2.dialogTitle === '提交') {
            (0, _leave.submitLeave)(_this2.form).then(function (res) {
              if (res.data) {
                _this2.$message.success("提交成功");
              } else {
                _this2.$message.error("提交失败");
              }
              _this2.cancelDialogAndRefresh();
            });
          } else if (_this2.dialogTitle === '重新提交') {
            (0, _leave.reSubmitLeave)(_this2.form).then(function (res) {
              if (res.data) {
                _this2.$message.success("重新提交成功");
              } else {
                _this2.$message.error("重新提交失败");
              }
              _this2.cancelDialogAndRefresh();
            });
          }
        }
      });
    },
    /**
     * 关闭弹出框 和 刷新表格
     */
    cancelDialogAndRefresh: function cancelDialogAndRefresh() {
      // 清空表单
      this.handleReset('form');
      // 刷新表格
      this.refresh();
    }
  }),
  mounted: function mounted() {
    var _this3 = this;
    this.getDictListByType('leave_type').then(function (res) {
      _this3.leaveTypeOptionList = res;
    });
  }
};